import { theme, ThemeConfig } from 'antd';

type Props = {
  isDark: boolean;
};

const tokens = {
  fontSize: 16,
  sizeStep: 4,
  borderRadius: 4,
  colorPrimary: '#1677ff',
  colorLink: '#69c0ff',
};

const appThemeFactory = ({ isDark }: Props): ThemeConfig =>
  isDark
    ? {
        algorithm: theme.darkAlgorithm,
        token: {
          colorTextBase: '#ffffff',
          ...tokens,
        },
        components: {
          Input: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
          InputNumber: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
          TextArea: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
        },
      }
    : {
        algorithm: theme.defaultAlgorithm,
        token: {
          colorTextBase: '#111111',
          ...tokens,
        },
        components: {
          Input: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
          InputNumber: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
          TextArea: {
            controlStyle: {
              userSelect: 'text',
            } as any,
          },
        },
      };

export { appThemeFactory };
